import React, { Component } from 'react'
import VideoPlayer from "../Helper/VideoPlayer"
import arrowDown from '../../assets/images/icons/arrow-down.png'
import arrowDoubleDown from '../../assets/images/icons/arrow-double-down.png'
import arrowDoubleUp from '../../assets/images/icons/arrow-double-up.png'
import ReactTooltip from 'react-tooltip'

export default class TestSupine extends Component {
  render() {
      const {onClick} = this.props;
    return (
        <div>
           
           <ReactTooltip />
          <div className="mt-3">
              <div className="row">
                <div className="col-lg-5">
                    <VideoPlayer src="https://www.youtube.com/embed/Qd8b8_gC0Wg" thumbnail='Supine-Head-Roll-11.jpg' width="300"/>
                </div>

                <div className="col-lg-6">
                  <p>Since you didn’t see any symptoms with the Dix-Hallpike, we’re going to move on to a maneuver called a&nbsp; 
                    {/* eslint-disable-next-line  */}
                    <a className="link" data-tip="Also known as the Pagnini-McClure maneuver, this diagnostic maneuver tests for the presence of Benign Paroxysmal Positional Vertigo (BPPV).">Supine Head Roll.</a>
                    &nbsp;Watch the video and perform the test as shown. 
                  </p>
                  <p>
                  Observe the eyes for involuntary movements during the test. The video will show some examples of what to look for.
                  </p>
                  <p>Then, select the option that best describes what you saw.</p>
                </div>
                
              </div>
              
              <div className="row mt-5">
                <div className="col-lg-3">
                  <button className="btn btn-dark w-100 p-2H text-left"  onClick={onClick.bind(this,22,true)}>
                  <div className="float-left">Apogeotropic</div>
                    <img  className="float-right" src={arrowDoubleUp} alt="arrow-double-up" width="40"/>
                  </button>
                </div>
                
                <div className="col-lg-3">               
                  <button className="btn btn-dark w-100 p-2H text-left"  onClick={onClick.bind(this,21,true)}>
                  <div className="float-left">Geotropic</div>
                    <img  className="float-right" alt="arrow-double-down" src={arrowDoubleDown} width="40"/>
                  </button>
                </div>
                
                <div className="col-lg-3">                
                  <button className="btn btn-dark w-100 p-2H text-left"  onClick={onClick.bind(this,17,true)}>
                  <div className="float-left">Downbeating</div>
                    <img  className="float-right" src={arrowDown} alt="arrow-down" width="20"/>
                  </button>
                </div>
                
                <div className="col-lg-3">  
                  <button className="btn btn-dark w-100 p-2H text-left"  onClick={onClick.bind(this,25,false)}>
                  <div className="float-left">None of these</div>
                    <i className="fa fa-ban float-right t-30"></i>
                  </button>
                </div>
              </div>
          </div>
         
        </div>

    )
  }
}
